export const Providers = {
    Email: "Email",
    Phone: "Phone",
    Authenticator: "Authenticator",
};
export const RESEND_COOLDOWN_SECONDS = 60;
